import React from "react";
import "../App.css";
import Show from './show';

function Results({ foundShows }) {

    function goAgain() {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });
        setTimeout(() => {
            document.querySelector('.searchInput').focus();
        }, 800);
        
    }

    return (
        <div className="results">
            {foundShows.map((show) => (
                <Show key={show.id} show={show}/>
            ))}
            <div className="again">
                <button onClick={goAgain}>Search again</button>
            </div>
        </div>
    );
}

export default Results;
